var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _path6, _ellipse, _rect4, _path7, _rect5, _rect6, _rect7, _rect8, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmusementParkThumbnailContrast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-light",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "#1E1E1E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-dark",
    x: 28.4736,
    y: 6.88318,
    width: 1.34213,
    height: 12.5266,
    rx: 0.671066,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M36.0697 11.6925L30.0675 7.98524C29.7627 7.79699 29.3696 8.01623 29.3696 8.37446V13.6705C29.3696 13.9708 29.6539 14.1896 29.9442 14.1128L35.9464 12.524C36.3347 12.4212 36.4115 11.9036 36.0697 11.6925Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M28.1974 15.7349C28.3721 15.5129 28.639 15.3833 28.9215 15.3833C29.204 15.3833 29.4708 15.5129 29.6455 15.7349L47.93 38.9714C49.1108 40.472 48.0418 42.6733 46.1324 42.6733H11.7106C9.80112 42.6733 8.73218 40.472 9.91296 38.9714L28.1974 15.7349Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light thumbnail-stroke-dark",
    d: "M16.6879 68.5686H16.6868V69.0686V84.6168H7.5V36.91H13.1435V42.2259V42.7259H13.6435H19.4013H19.9013V42.2259V36.91H25.5448V42.2259V42.7259H26.0448H31.8026H32.3026V42.2259V36.91H37.9461V42.2259V42.7259H38.4461H44.6468H45.1468V42.2259V36.91H50.7903V84.6168H41.1606V69.0686V68.5686H41.1595C41.1603 68.5116 41.1606 68.4546 41.1606 68.3975C41.1606 61.5785 35.6867 56.042 28.9237 56.042C22.1607 56.042 16.6868 61.5785 16.6868 68.3975C16.6868 68.4546 16.6872 68.5116 16.6879 68.5686Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light thumbnail-stroke-dark",
    d: "M68.5984 49.5719L68.7598 49.073L68.2538 48.9355C65.7658 48.2598 63.9414 45.9995 63.9414 43.3207C63.9414 40.1092 66.5635 37.5 69.8053 37.5C72.6124 37.5 74.9566 39.4575 75.5332 42.068L75.6245 42.4815L76.0475 42.4594C76.1162 42.4559 76.1855 42.454 76.2552 42.454C78.4046 42.454 80.1411 44.1837 80.1411 46.3102C80.1411 48.3095 78.606 49.9582 76.636 50.1481L76.173 50.1927L76.1841 50.6577C76.1848 50.6889 76.1852 50.7202 76.1852 50.7517C76.1852 52.8782 74.4486 54.6078 72.2993 54.6078C70.1499 54.6078 68.4133 52.8782 68.4133 50.7517C68.4133 50.3394 68.4783 49.9432 68.5984 49.5719Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M67.9131 56.3036H77.2009L76.6849 64.1617H68.6011L67.9131 56.3036Z",
    fill: "#1E1E1E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-dark",
    x: 29,
    y: 82.9625,
    width: 56.2871,
    height: 6.3891,
    fill: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M94.7854 92.7937L85.9606 83.6225C85.8308 83.4876 85.6517 83.4114 85.4645 83.4114H80.6652C80.285 83.4114 79.9768 83.7196 79.9768 84.0998V93.271C79.9768 93.6512 80.285 93.9594 80.6652 93.9594H94.2893C94.8963 93.9594 95.2062 93.231 94.7854 92.7937Z",
    fill: "#1E1E1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "thumbnail-fill-dark",
    cx: 83.163,
    cy: 74.4456,
    rx: 10.0206,
    ry: 9.55818,
    transform: "rotate(90 83.163 74.4456)",
    fill: "#1E1E1E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-dark",
    x: 55.5505,
    y: 64.4249,
    width: 28.6745,
    height: 20.0413,
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M33.5222 52.822H56.6125V84.4662H29L29 80.7836C29 78.7409 30.6559 77.0849 32.6987 77.0849H33.5222V68.6441V52.822Z",
    fill: "#1E1E1E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-dark",
    x: 31.7939,
    y: 51.0079,
    width: 26.4876,
    height: 2.73326,
    rx: 0.809765,
    fill: "#1E1E1E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-light",
    x: 36.4343,
    y: 55.9865,
    width: 16.9923,
    height: 14.7673,
    rx: 0.809765,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-dark",
    x: 35.406,
    y: 72.7032,
    width: 5.50391,
    height: 1.70829,
    rx: 0.809765,
    fill: "#1E1E1E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-fill-light",
    x: 56.5615,
    y: 66.0409,
    width: 27.6916,
    height: 5.46652,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light thumbnail-stroke-dark",
    d: "M54.0136 84.9175C54.0136 89.7837 50.0399 93.7402 45.1237 93.7402C40.2076 93.7402 36.2339 89.7837 36.2339 84.9175C36.2339 80.0513 40.2076 76.0948 45.1237 76.0948C50.0399 76.0948 54.0136 80.0513 54.0136 84.9175Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light thumbnail-stroke-dark",
    d: "M68.2865 88.3326C68.2865 91.3111 65.8536 93.7372 62.8381 93.7372C59.8226 93.7372 57.3896 91.3111 57.3896 88.3326C57.3896 85.3541 59.8226 82.928 62.8381 82.928C65.8536 82.928 68.2865 85.3541 68.2865 88.3326Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-light thumbnail-stroke-dark",
    d: "M82.9088 88.3326C82.9088 91.3111 80.4759 93.7372 77.4604 93.7372C74.4449 93.7372 72.012 91.3111 72.012 88.3326C72.012 85.3541 74.4449 82.928 77.4604 82.928C80.4759 82.928 82.9088 85.3541 82.9088 88.3326Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-fill-dark",
    d: "M67.3486 54.6901C67.3768 54.5363 67.5108 54.4246 67.6672 54.4246H77.4471C77.6035 54.4246 77.7375 54.5363 77.7657 54.6901L77.9911 55.9214C78.0275 56.1204 77.8747 56.3037 77.6725 56.3037H67.4418C67.2396 56.3037 67.0868 56.1204 67.1232 55.9214L67.3486 54.6901Z",
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmusementParkThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AmusementParkThumbnailContrast.7e0e357d14d12134a9d7e589ee246b7e.svg";